<template>
  <div v-if="showCorrected">
    <span class="custom-font-semi-bold status-text">{{ percentageCorrected }}% CORREGIDO</span>
    <v-progress-circular :value="percentageCorrected" color="#95d8f5" size="30" :rotate="-90"></v-progress-circular>
  </div>
  <div v-else>
    <span class="custom-font-semi-bold status-text">{{ percentageCharged }}% CARGADO</span>
    <v-progress-circular :value="percentageCharged" color="#95d8f5" size="30" :rotate="-90"></v-progress-circular>
  </div>
</template>

<script>
import Constants from '../../../common/constants'

const MAX_PERCENTAGE = 100
const NO_PRESENTADO = Constants.NO_PRESENTADO
const REVISADO_INCOMPLETO = Constants.REVISADO_INCOMPLETO
const REVISADO_OK = Constants.REVISADO_OK
const A_REVISAR = Constants.A_REVISAR

export default {
  props: {
    criterios: Array,
    showCorrected: Boolean
  },

  data () {
    return {
      correctedStatuses: [REVISADO_OK, REVISADO_INCOMPLETO],
      chargedStatuses: [A_REVISAR, REVISADO_OK]
    }
  },

  computed: {
    percentageCharged () {
      return this.calculatePercentage(this.isCharged)
    },
    percentageCorrected () {
      return this.calculatePercentage(this.isCorrected)
    },
    totalRequirements () {
      return this.criterios.reduce((total, criterio) => {
        return total + this.getMandatoryRequerimientosFromCriterio(criterio).length
      }, 0)
    }
  },

  methods: {
    isCorrected (requerimiento) {
      return this.correctedStatuses.includes(requerimiento.estadoDisplay)
    },
    isCharged (requerimiento) {
      return this.chargedStatuses.includes(requerimiento.estadoDisplay)
    },
    calculatePercentage (bindingBooleanFunction) {
      if (!this.totalRequirements) return MAX_PERCENTAGE
      let percentage = Math.floor(this.countPercentage(bindingBooleanFunction) * MAX_PERCENTAGE / this.totalRequirements)
      return Math.min(percentage, MAX_PERCENTAGE)
    },
    getMandatoryRequerimientosFromCriterio (criterio) {
      return criterio.requerimientos.filter(
        requerimiento => !(requerimiento.optional && requerimiento.estadoDisplay === NO_PRESENTADO)
      )
    },
    countPercentage (bindingBooleanFunction) {
      let total = 0
      for (let criterio of this.criterios) {
        for (let requerimiento of this.getMandatoryRequerimientosFromCriterio(criterio)) {
          total += bindingBooleanFunction(requerimiento)
        }
      }
      return total
    }
  }
}
</script>

<style scoped>
.status-text {
  font-size: 1.05em;
  margin-right: 0.5em;
}
</style>
